// extracted by mini-css-extract-plugin
export default {"col":"ArticleThumb_col__tDH2p","imageWrapper":"ArticleThumb_imageWrapper__MTcLu","span":"ArticleThumb_span__XZCRq"};